<template>
  <NuxtLayout
    name="layout"
    type="error"
  />
</template>

<script setup>
const { isNotOverflow } = useHelpers()

isNotOverflow.value = false
const preloader = ref(true)

useHead({
  viewport: 'width=device-width, initial-scale=1',  // maximum-scale=5
  charset: 'utf-8'
})

/**
* MAIN LOGIC
*/
onMounted(() => {
  preloader.value = false
})
</script>
